module.exports = __webpack_public_path__ + "static/img/xiugai.b9c534e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/view6/xiugai.png
// module id = eiwc
// module chunks = 1